"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getBidPrices_1 = require("./getBidPrices");
var getKevelImpressionCPI = function (shim) {
    // These shims are unreliable, so may break without notice
    var rawCPM = shim.dp ? shim.dp : shim.pc ? shim.pc : shim.ec ? shim.ec : 0;
    return (0, getBidPrices_1.getBidPrices)(rawCPM, "cpm").cpi;
};
exports.default = getKevelImpressionCPI;
